import CryptoJS from 'crypto-js'

function base64url (source) {
  let encodedSource = CryptoJS.enc.Base64.stringify(source)

  encodedSource = encodedSource.replace(/=+$/, '')

  encodedSource = encodedSource.replace(/\+/g, '-')
  encodedSource = encodedSource.replace(/\//g, '_')

  return encodedSource
}

export {
  base64url
}



// WEBPACK FOOTER //
// ./src/helpers/crypto.js